import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { initAnalytics, trackPageView } from "./analytics";

// One hook to wire GA4 into the SPA: tries to initialise on mount and
// on every subsequent route change (in case consent was just granted),
// and fires a page_view event whenever the route changes. Drop this
// into MarketingLayout — it has no UI.
export default function useAnalytics(): void {
    const location = useLocation();

    useEffect(() => {
        initAnalytics();
        trackPageView(location.pathname + location.search);
    }, [location.pathname, location.search]);
}
